import React, { useEffect, useRef, useState } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import { PDFDocument, rgb } from "pdf-lib";
import { saveAs } from "file-saver";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import "./PdfAnnotator.css";
import "./header.css"; 
import eraserr from "./eraser.png"
import { toast } from 'react-toastify';
import ENVURL from "./env";


pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

// const getFileUrlFromQuery = () => {
//   const params = new URLSearchParams(window.location.search);
//   return params.get("fileurl");


// };

// const getParamsFromQuery = () => {
//     const params = new URLSearchParams(window.location.search);
//     return {
//       fileUrl: params.get("fileurl"),
//       studentId: params.get("student_id"),
//       fileId: params.get("file_id"),
//       instId: params.get("inst_id"),
//       authToken: params.get("auth"),
//       attachId:params.get("attachment_id")

//     };
//   };
  
// const gettools = () => {
//     const params = new URLSearchParams(window.location.search);
  
//     const getBool = (key, defaultVal = true) => {
//       const val = params.get(key);
//       return val === null ? defaultVal : val === "true";
//     };
  
//     return {
//       pencil: getBool("showPencil"),
//       text: getBool("showText"),
//       highlight: getBool("showHighlight"),
//       freeDrawing: getBool("showFreeDrawing"),
//       symbol:getBool("showSymbol"),
//       color: getBool("showColor"),
//       size: getBool("showSize"),
//       undo: getBool("showUndo"),
//       redo: getBool("showRedo"),
//       save: getBool("showSave"),
//       download: getBool("showDownload"),
//       emoji:getBool("showEmoji"),
//       eraser:getBool("showEraser"),
//       reset:getBool("showReset"),
     
//     };
//   };
  
 
// const PdfAnnotator = () => {
  const PdfAnnotator = ({
    fileUrl,
    studentId,
    fileId,
    instId,
    authToken,
    attachId,
    fileName,
    tools
  }) => {
    const file = fileUrl;
    // and use props directly instead of parsing window.location
    const handleMoveRef = useRef(null);
    const handleUpRef = useRef(null);
    
  // const [file, setFile] = useState(null);  // Add file state
  const [numPages, setNumPages] = useState(null);
  const [tool, setTool] = useState("pencil");
  const [color, setColor] = useState("#FF0000");
  const [fontSize, setFontSize] = useState(26);
  const [pdfDoc, setPdfDoc] = useState(null);
  const canvasRefs = useRef([]);
  const drawnLines = useRef([]);
  const [activePage, setActivePage] = useState(0);
  const [textBoxes, setTextBoxes] = useState([]);
  const [selectedBox, setSelectedBox] = useState(null);
  // const [fileName,setFileName]=useState(null)
  const [history, setHistory] = useState([]);
  const [drawnLinesState, setDrawnLinesState] = useState([]);
  const [textBoxesState, setTextBoxesState] = useState([]);
  const [selectedSymbolBox, setSelectedSymbolBox] = useState(null);
  const drawnEmojis = useRef({}); // 🆕 { pageIndex: [ { id, x, y, emoji } ] }
  // const [studentId, setStudentId] = useState(null);
  // const [fileId, setFileId] = useState(null);
  // const [instId, setInstId] = useState(null);
  // const [authToken, setAuthToken] = useState(null);
    // const [attachId,setAttachId]=useState(null)
const [showConfirmation, setShowConfirmation] = useState(false);
const backupState = useRef(null);
const [pageDimensions, setPageDimensions] = useState({});

  const undoStack = useRef([]);
  const redoStack = useRef([]);
  const pathsRef = useRef({}); // Store paths for drawing
  const drawnSymbols = useRef({});
const [symbolColor, setSymbolColor] = useState('black');
const [symbolSize, setSymbolSize] = useState(30);
const isDraggingSymbolRef = useRef(false);
const dragTargetRef = useRef(null);
const dragOffsetXRef = useRef(0);
const dragOffsetYRef = useRef(0);
let selectedElement = null;
// const [tools, settools] = useState(gettools());

const [isDropdownVisible, setDropdownVisible] = useState(false); 
const [showOriginal, setShowOriginal] = useState(false);

  const [selectedSymbol, setSelectedSymbol] = useState('✓');
  const canvasRef = useRef(null);
  const [selectedEmoji, setSelectedEmoji] = useState('😀');
  const [emojiAnnotations, setEmojiAnnotations] = useState([]); // each item: { id, pageIndex, x, y, emoji }
  const [eraserRect, setEraserRect] = useState({
    x: 100,
    y: 100,
    width: 40,
    height: 40,
  });
  const [isResizingEraser, setIsResizingEraser] = useState(false);
  const [isDraggingEraser, setIsDraggingEraser] = useState(false);
  const eraserRef = useRef(null);
 const handleSaveClick = () => {
    setShowConfirmation(true);
  };
  
  const drawSymbol = (ctx, symbol, x, y, fontSize, color) => {
    // Set the font size and color for the symbol
    ctx.font = `${fontSize}px Arial`;
    ctx.fillStyle = color;
  
    // Ensure we don't draw a stray dot by positioning the symbol carefully
    // Adjust the `x` and `y` position so that the symbol is centered properly
    const adjustedX = x - fontSize / 2; // Adjust X to center symbol if necessary
    const adjustedY = y + fontSize / 2; // Adjust Y to properly place the symbol
  
    // Draw the symbol
    ctx.fillText(symbol, adjustedX, adjustedY);
  };
  
  const drawEmoji = (ctx, emoji, x, y) => {
    ctx.font = "24px Arial";
    ctx.textAlign = "center";
    ctx.textBaseline = "middle";
    ctx.fillText(emoji, x, y);
  };
  
 
  const handleUndo = () => {
    const lastAction = undoStack.current.pop();
    if (!lastAction) return;
    redoStack.current.push(lastAction);
  
    const { pageIndex } = lastAction;
    if (lastAction.type === 'reset-all') {
        const restoredBoxes = [];
      
        lastAction.pages.forEach((page) => {
          drawnLines.current[page.pageIndex] = [...page.lines];
          drawnSymbols.current[page.pageIndex] = [...page.symbols];
          drawnEmojis.current[page.pageIndex] = [...page.emojis];
          restoredBoxes.push(...page.texts);
          drawAllLines(page.pageIndex);
        });
      
        setTextBoxes((prev) => [...prev, ...restoredBoxes]);
      }
      
  
    if (lastAction.type === "draw") {
      drawnLines.current[pageIndex] = drawnLines.current[pageIndex].filter(
        (line) => line !== lastAction.line
      );
    } else if (lastAction.type === "free-draw") {
      if (lastAction.action === "erase") {
        drawnLines.current[pageIndex].push(...lastAction.lines);
      } else {
        drawnLines.current[pageIndex] = drawnLines.current[pageIndex].filter(
          (line) => !lastAction.lines.includes(line)
        );
      }
    } if (lastAction.type === "text") {
      if (lastAction.action === "add") {
        // Undoing an 'add' = remove the box
        setTextBoxes((prev) => prev.filter((b) => b.id !== lastAction.box.id));
      } else if (lastAction.action === "erase") {
        // Undoing an 'erase' = restore the full box
        setTextBoxes((prev) => [...prev, ...lastAction.boxes.map((b) => ({ ...b }))]);
      }
    }
    else if (lastAction.type === "symbol") {
      if (lastAction.action === "add") {
        drawnSymbols.current[pageIndex] = drawnSymbols.current[pageIndex].filter(
          (s) => s.id !== lastAction.symbol.id
        );
      } else if (lastAction.action === "erase") {
        drawnSymbols.current[pageIndex].push(...lastAction.items);
      }
    } else if (lastAction.type === "emoji") {
      if (lastAction.action === "add") {
        drawnEmojis.current[pageIndex] = drawnEmojis.current[pageIndex].filter(
          (e) => e.id !== lastAction.emoji.id
        );
      } else if (lastAction.action === "erase") {
        drawnEmojis.current[pageIndex].push(...lastAction.items);
      }
    }
  
    drawAllLines(pageIndex);
  };
 
  const handleRedo = () => {
    const nextAction = redoStack.current.pop();
    if (!nextAction) return;
    undoStack.current.push(nextAction);
  
    const { pageIndex } = nextAction;
    if (nextAction.type === 'reset-all') {
        nextAction.pages.forEach((page) => {
          drawnLines.current[page.pageIndex] = [];
          drawnSymbols.current[page.pageIndex] = [];
          drawnEmojis.current[page.pageIndex] = [];
          drawAllLines(page.pageIndex);
        });
      
        setTextBoxes((prev) =>
          prev.filter((box) =>
            !nextAction.pages.some((page) => page.pageIndex === box.pageIndex)
          )
        );
      }
      
  
    if (nextAction.type === "draw") {
      drawnLines.current[pageIndex].push(nextAction.line);
    } else if (nextAction.type === "free-draw") {
      if (nextAction.action === "erase") {
        drawnLines.current[pageIndex] = drawnLines.current[pageIndex].filter(
          (line) => !nextAction.lines.includes(line)
        );
      } else {
        drawnLines.current[pageIndex].push(...nextAction.lines);
      }
    } if (nextAction.type === "text") {
      if (nextAction.action === "add") {
        setTextBoxes((prev) => [...prev, { ...nextAction.box }]);
      } else if (nextAction.action === "erase") {
        setTextBoxes((prev) =>
          prev.filter((b) => !nextAction.boxes.some((bx) => bx.id === b.id))
        );
      }
    }
    
     else if (nextAction.type === "symbol") {
      if (nextAction.action === "add") {
        drawnSymbols.current[pageIndex].push(nextAction.symbol);
      } else if (nextAction.action === "erase") {
        drawnSymbols.current[pageIndex] = drawnSymbols.current[pageIndex].filter(
          (s) => !nextAction.items.some((i) => i.id === s.id)
        );
      }
    } else if (nextAction.type === "emoji") {
      if (nextAction.action === "add") {
        drawnEmojis.current[pageIndex].push(nextAction.emoji);
      } else if (nextAction.action === "erase") {
        drawnEmojis.current[pageIndex] = drawnEmojis.current[pageIndex].filter(
          (e) => !nextAction.items.some((i) => i.id === e.id)
        );
      }
    }
  
    drawAllLines(pageIndex);
  };
  
  const addActionToHistory = (action) => {
    undoStack.current.push(action);
    redoStack.current = [];
  };
  
  const handleReset = () => {
    const allResetData = {
      type: 'reset-all',
      pages: [],
    };
  
    const totalPages = numPages;
  
    for (let i = 0; i < totalPages; i++) {
      allResetData.pages.push({
        pageIndex: i,
        lines: [...(drawnLines.current[i] || [])],
        symbols: [...(drawnSymbols.current[i] || [])],
        emojis: [...(drawnEmojis.current[i] || [])],
        texts: textBoxes.filter((b) => b.pageIndex === i),
      });
  
      drawnLines.current[i] = [];
      drawnSymbols.current[i] = [];
      drawnEmojis.current[i] = [];
    }
  
    setTextBoxes([]);
  
    undoStack.current.push(allResetData);
    redoStack.current = [];
  
    for (let i = 0; i < totalPages; i++) {
      drawAllLines(i);
    }
  };
  const eraseIntersectingObjects = (rectOverride = null) => {
    const pageIndex = activePage;
    const { x, y, width, height } = rectOverride || eraserRect;
    const rect = {
      left: x,
      top: y,
      right: x + width,
      bottom: y + height,
    };
  
    // ✅ Erase partial lines (pencil, highlight, free-drawing)
    const removedLines = [];
    drawnLines.current[pageIndex] = drawnLines.current[pageIndex].filter((line) => {
      const intersects =
        (line.start.x >= rect.left && line.start.x <= rect.right &&
         line.start.y >= rect.top && line.start.y <= rect.bottom) ||
        (line.end.x >= rect.left && line.end.x <= rect.right &&
         line.end.y >= rect.top && line.end.y <= rect.bottom);
  
      if (intersects) removedLines.push(line);
      return !intersects;
    });
  
    if (removedLines.length) {
      addActionToHistory({
        type: 'free-draw',
        action: 'erase',
        pageIndex,
        lines: removedLines,
      });
    }
  
    // ❌ Fully remove intersecting symbols
    const removedSymbols = [];
    drawnSymbols.current[pageIndex] = drawnSymbols.current[pageIndex]?.filter((sym) => {
      const inEraser =
        sym.x >= rect.left && sym.x <= rect.right &&
        sym.y >= rect.top && sym.y <= rect.bottom;
      if (inEraser) removedSymbols.push(sym);
      return !inEraser;
    }) || [];
    if (removedSymbols.length) {
      addActionToHistory({
        type: 'symbol',
        action: 'erase',
        pageIndex,
        items: removedSymbols,
      });
    }
  
    // ❌ Fully remove intersecting emojis
    const removedEmojis = [];
    drawnEmojis.current[pageIndex] = drawnEmojis.current[pageIndex]?.filter((emo) => {
      const inEraser =
        emo.x >= rect.left && emo.x <= rect.right &&
        emo.y >= rect.top && emo.y <= rect.bottom;
      if (inEraser) removedEmojis.push(emo);
      return !inEraser;
    }) || [];
    if (removedEmojis.length) {
      addActionToHistory({
        type: 'emoji',
        action: 'erase',
        pageIndex,
        items: removedEmojis,
      });
    }
  
    // ❌ Fully remove intersecting text boxes
    setTextBoxes((prev) => {
      const remaining = [];
      const removed = [];
      for (const box of prev) {
        if (box.pageIndex !== pageIndex) {
          remaining.push(box);
          continue;
        }
        const overlaps =
          box.left < rect.right &&
          box.left + box.width > rect.left &&
          box.top < rect.bottom &&
          box.top + box.height > rect.top;
        if (overlaps) {
          removed.push(box);
        } else {
          remaining.push(box);
        }
      }
  
      if (removed.length) {
        addActionToHistory({
          type: 'text',
          action: 'erase',
          pageIndex,
          boxes: removed,
        });
      }
  
      return remaining;
    });
  
    drawAllLines(pageIndex);
  };
  
  useEffect(() => {
    if (!isDraggingEraser) return;
  
    const handleMove = (e) => {
      if (tool !== 'eraser' || !isDraggingEraser) return;
      const canvas = canvasRefs.current[activePage];
      if (!canvas) return;
    
      e.preventDefault();
    
      let pageX = e.pageX;
      let pageY = e.pageY;
    
      if (e.touches && e.touches.length > 0) {
        pageX = e.touches[0].pageX;
        pageY = e.touches[0].pageY;
      }
    
      const updated = {
        ...eraserRect,
        x: pageX - eraserRect.width / 2,
        y: pageY - eraserRect.height / 2,
      };
    
      setEraserRect(updated);
      eraseIntersectingObjects(updated);
    };
    
  
    const handleUp = () => setIsDraggingEraser(false);
  
    window.addEventListener("mousemove", handleMove);
    window.addEventListener("mouseup", handleUp);
    window.addEventListener("touchmove", handleMove, { passive: false });
    window.addEventListener("touchend", handleUp);
  
    return () => {
      window.removeEventListener("mousemove", handleMove);
      window.removeEventListener("mouseup", handleUp);
      window.removeEventListener("touchmove", handleMove);
      window.removeEventListener("touchend", handleUp);
    };
  }, [isDraggingEraser, activePage, tool, eraserRect, canvasRefs, eraseIntersectingObjects]);
  
  
  
  

  // Guard against undefined refs
  
  // Load the file URL from the query string
  // useEffect(() => {
  //   const { fileUrl, studentId, fileId, instId, authToken,attachId } = getParamsFromQuery();
    
  //   if (fileUrl) {
  //     setFile(fileUrl);  
  //     setFileName(fileUrl.split("/").pop());
  //   }
  
  //   setStudentId(studentId);
  //   setFileId(fileId);
  //   setInstId(instId);
  //   setAuthToken(authToken);
  //   setAttachId(attachId)

  // }, []);
  

  useEffect(() => {
    const loadPdf = async () => {
      if (file) {
        const response = await fetch(file);  // Fetch the PDF file from the URL
        const arrayBuffer = await response.arrayBuffer();
        const pdf = await PDFDocument.load(arrayBuffer);
        setPdfDoc(pdf);
      }
    };
    if (file) loadPdf();  // Only load if file URL is set
  }, [file]);

  useEffect(() => {
    const handleClickOutside = () => setSelectedBox(null);
    window.addEventListener("click", handleClickOutside);
    return () => window.removeEventListener("click", handleClickOutside);
  }, []);

  useEffect(() => {
    if (numPages) {
      for (let i = 0; i < numPages; i++) {
        drawAllLines(i);
      }
    }
  }, [numPages, drawnLines.current]);

  const handleLoadSuccess = (pdf) => {
    setNumPages(pdf.numPages);
    drawnLines.current = Array(pdf.numPages).fill().map(() => []);
  };


 
  
  
  const drawLine = (ctx, line) => {
    ctx.strokeStyle = line.tool === "highlight" ? line.color + "70" : line.color;
    ctx.lineWidth = line.tool === "highlight" ? 20 : 2;
    ctx.lineCap = "round";
    ctx.lineJoin = "round";
    ctx.beginPath();
    ctx.moveTo(line.start.x, line.start.y);
    ctx.lineTo(line.end.x, line.end.y);
    ctx.stroke();}

    

      
      const handleCanvasClick = (e, pageIndex) => {
        if (tool !== 'eraser') return;
        const canvas = canvasRefs.current[pageIndex];
        if (!canvas) return;
        const rect = canvas.getBoundingClientRect();
        const clickX = e.clientX - rect.left;
        const clickY = e.clientY - rect.top;
      
        setEraserRect((prev) => ({
          ...prev,
          x: clickX - prev.width / 2,
          y: clickY - prev.height / 2,
        }));
      };
      const drawAllLines = (pageIndex) => {
        const canvas = canvasRefs.current[pageIndex];
        if (!canvas) return;
        if (showOriginal) return;
    
        const ctx = canvas.getContext("2d");
        ctx.clearRect(0, 0, canvas.width, canvas.height);
    
        // 🟡 Redraw all lines
        drawnLines.current[pageIndex]?.forEach(line => drawLine(ctx, line));
    
        // 🔴 Redraw all symbols
        drawnSymbols.current[pageIndex]?.forEach(symbol => {
            drawSymbol(ctx, symbol.symbol, symbol.x, symbol.y, symbol.fontSize, symbol.color);
    
            // 🔷 Draw selection/resize only for selected symbol
            if (tool === 'symbol' && selectedElement === symbol) {
                ctx.strokeStyle = 'blue';
                ctx.lineWidth = 1;
                ctx.strokeRect(symbol.x - 5, symbol.y - symbol.fontSize, symbol.fontSize + 10, symbol.fontSize + 10);
    
                const handleX = symbol.x + symbol.fontSize + 2;
                const handleY = symbol.y + 2;
                ctx.fillStyle = 'white';
                ctx.strokeStyle = 'black';
                ctx.lineWidth = 1;
                ctx.fillRect(handleX, handleY, 10, 10);
                ctx.strokeRect(handleX, handleY, 10, 10);
            }
        });
    
        // 🟢 Redraw all emojis
        drawnEmojis.current[pageIndex]?.forEach((emoji) => {
            ctx.font = `${emoji.fontSize || 24}px Arial`;
            ctx.textAlign = "center";
            ctx.textBaseline = "middle";
            ctx.fillText(emoji.emoji, emoji.x, emoji.y);
        });
    };
    
    
      
      
    const isDrawingRef = useRef(false);  // Tracks drawing state

    // Utility to get coordinates for both mouse and touch
  
    

// Utility to get coordinates for both mouse and touch
const getXY = (e, rect) => {
  if (e.touches && e.touches.length > 0) {
    return {
      x: e.touches[0].clientX - rect.left,
      y: e.touches[0].clientY - rect.top,
    };
  } else {
    return {
      x: e.clientX - rect.left,
      y: e.clientY - rect.top,
    };
  }
};
// useEffect(() => {
//   if (!eraserRef.current) return;

//   const handleMove = (e) => {
//     e.preventDefault();
  
//     const canvas = canvasRefs.current[activePage];
//     if (!canvas) return;
  
//     const rect = canvas.getBoundingClientRect();
  
//     let clientX, clientY;
//     if (e.touches && e.touches.length > 0) {
//       clientX = e.touches[0].clientX;
//       clientY = e.touches[0].clientY;
//     } else {
//       clientX = e.clientX;
//       clientY = e.clientY;
//     }
  
//     setEraserRect((prev) => ({
//       ...prev,
//       x: clientX - rect.left - prev.width / 2, // offset by canvas and half eraser size
//       y: clientY - rect.top - prev.height / 2,
//     }));
  
//     // Call erase logic
//     eraseIntersectingObjects({
//       ...eraserRect,
//       x: clientX - rect.left - eraserRect.width / 2,
//       y: clientY - rect.top - eraserRect.height / 2,
//     });
//   };
  
//   const handleUp = () => {
//     setIsDraggingEraser(false);
//   };

//   if (isDraggingEraser) {
//     window.addEventListener("mousemove", handleMove);
//     window.addEventListener("mouseup", handleUp);
//     window.addEventListener("touchmove", handleMove, { passive: false });
//     window.addEventListener("touchend", handleUp);
//   }

//   return () => {
//     window.removeEventListener("mousemove", handleMove);
//     window.removeEventListener("mouseup", handleUp);
//     window.removeEventListener("touchmove", handleMove);
//     window.removeEventListener("touchend", handleUp);
//   };
// }, [isDraggingEraser]);
const handleEraserMove = (e) => {
  if (tool !== "eraser" || !isDraggingEraser) return;

  const canvas = canvasRefs.current[activePage];
  if (!canvas) return;
  const rect = canvas.getBoundingClientRect();

  let clientX = e.clientX;
  let clientY = e.clientY;

  if (e.touches && e.touches.length > 0) {
    clientX = e.touches[0].clientX;
    clientY = e.touches[0].clientY;
  }

  // Convert to canvas coordinates
  const x = (clientX - rect.left) * (canvas.width / rect.width);
  const y = (clientY - rect.top) * (canvas.height / rect.height);

  const updated = {
    ...eraserRect,
    x: x - eraserRect.width / 2,
    y: y - eraserRect.height / 2,
  };

  setEraserRect(updated);
  eraseIntersectingObjects(updated);
};

useEffect(() => {
  if (!isDraggingEraser) return;

  window.addEventListener("mousemove", handleEraserMove);
  window.addEventListener("mouseup", () => setIsDraggingEraser(false));
  window.addEventListener("touchmove", handleEraserMove, { passive: false });
  window.addEventListener("touchend", () => setIsDraggingEraser(false));

  return () => {
    window.removeEventListener("mousemove", handleEraserMove);
    window.removeEventListener("mouseup", () => setIsDraggingEraser(false));
    window.removeEventListener("touchmove", handleEraserMove);
    window.removeEventListener("touchend", () => setIsDraggingEraser(false));
  };
}, [isDraggingEraser, activePage, tool, eraserRect]);

const handleMouseDown = (pageIndex, e) => {
  const canvas = canvasRefs.current[pageIndex];
  if (!canvas) return;

  const rect = canvas.getBoundingClientRect();
  const ctx = canvas.getContext("2d");

  const getXYRelative = (event, rect) => {
    let pageX = event.pageX;
    let pageY = event.pageY;

    if (event.touches && event.touches.length > 0) {
      pageX = event.touches[0].pageX;
      pageY = event.touches[0].pageY;
    }

    return {
      x: pageX - rect.left,
      y: pageY - rect.top,
    };
  };

  const { x: startX, y: startY } = getXYRelative(e, rect);

  // --- SYMBOL TOOL ---
  if (tool === "emoji" && selectedEmojiRef.current) {
    const newEmoji = {
      id: Date.now(),
      pageIndex,
      x: startX,
      y: startY,
      fontSize,
      emoji: selectedEmojiRef.current,
    };

    if (!drawnEmojis.current[pageIndex]) drawnEmojis.current[pageIndex] = [];
    drawnEmojis.current[pageIndex].push(newEmoji);
    drawEmoji(ctx, newEmoji.emoji, newEmoji.x, newEmoji.y);

    addActionToHistory({ type: "emoji", action: "add", pageIndex, emoji: newEmoji });
    setSelectedEmoji(null);
    return;
  }

  if (tool === "symbol" && selectedSymbolRef.current) {
    const newSymbol = {
      id: Date.now(),
      type: "symbol",
      symbol: selectedSymbolRef.current,
      x: startX,
      y: startY,
      fontSize,
      color,
    };

    if (!drawnSymbols.current[pageIndex]) drawnSymbols.current[pageIndex] = [];
    drawnSymbols.current[pageIndex].push(newSymbol);
    drawSymbol(ctx, newSymbol.symbol, newSymbol.x, newSymbol.y, newSymbol.fontSize, newSymbol.color);

    addActionToHistory({ type: "symbol", action: "add", pageIndex, symbol: newSymbol });
    setSelectedSymbol(null);
    return;
  }

  // --- ERASER TOOL ---
  const ERASER_SIZE = 32;

  if (tool === "eraser") {
    const newEraser = {
      x: startX - ERASER_SIZE / 2,
      y: startY - ERASER_SIZE / 2,
      width: ERASER_SIZE,
      height: ERASER_SIZE,
    };
    setEraserRect(newEraser);
    eraseIntersectingObjects(newEraser);
    setIsDraggingEraser(true);
  }

  // --- PENCIL / HIGHLIGHTER LOGIC ---
  let lastX = startX;
  let lastY = startY;
  let linesDrawn = [];
  isDrawingRef.current = true;

  // Remove previous listeners
  if (handleMoveRef.current) {
    window.removeEventListener("mousemove", handleMoveRef.current);
    window.removeEventListener("touchmove", handleMoveRef.current);
  }
  if (handleUpRef.current) {
    window.removeEventListener("mouseup", handleUpRef.current);
    window.removeEventListener("touchend", handleUpRef.current);
  }

  const handleMove = (moveEvent) => {
    moveEvent.preventDefault();
    if (!isDrawingRef.current) return;

    const { x, y } = getXYRelative(moveEvent, rect);

    if (tool === "pencil") {
      lastX = x;
      lastY = y;
    } else if (tool === "eraser") {
      const updatedEraser = {
        x: x - ERASER_SIZE / 2,
        y: y - ERASER_SIZE / 2,
        width: ERASER_SIZE,
        height: ERASER_SIZE,
      };
      setEraserRect(updatedEraser);
      eraseIntersectingObjects(updatedEraser);
      drawAllLines(pageIndex);
      return;
    } else {
      // highlighter / free-draw
      ctx.strokeStyle = tool === "highlighter" ? color + "70" : color;
      ctx.lineWidth = tool === "highlighter" ? 20 : 2;
      ctx.lineCap = "round";

      ctx.beginPath();
      ctx.moveTo(lastX, lastY);
      ctx.lineTo(x, y);
      ctx.stroke();

      const line = {
        start: { x: lastX, y: lastY },
        end: { x, y },
        color: ctx.strokeStyle,
        tool,
      };
      linesDrawn.push(line);

      if (!drawnLines.current[pageIndex]) drawnLines.current[pageIndex] = [];
      drawnLines.current[pageIndex].push(line);

      lastX = x;
      lastY = y;
    }
  };

  const handleUp = () => {
    isDrawingRef.current = false;

    if (tool === "pencil") {
      ctx.strokeStyle = color;
      ctx.lineWidth = 2;
      ctx.lineCap = "round";

      ctx.beginPath();
      ctx.moveTo(startX, startY);
      ctx.lineTo(lastX, lastY);
      ctx.stroke();

      const line = {
        start: { x: startX, y: startY },
        end: { x: lastX, y: lastY },
        color: ctx.strokeStyle,
        tool,
      };

      if (!drawnLines.current[pageIndex]) drawnLines.current[pageIndex] = [];
      drawnLines.current[pageIndex].push(line);
      addActionToHistory({ type: "free-draw", pageIndex, lines: [line] });
    } else if (tool !== "eraser" && linesDrawn.length > 0) {
      addActionToHistory({ type: "free-draw", pageIndex, lines: [...linesDrawn] });
    }

    drawAllLines(pageIndex);

    window.removeEventListener("mousemove", handleMoveRef.current);
    window.removeEventListener("mouseup", handleUpRef.current);
    window.removeEventListener("touchmove", handleMoveRef.current);
    window.removeEventListener("touchend", handleUpRef.current);

    setIsDraggingEraser(false);
  };

  handleMoveRef.current = handleMove;
  handleUpRef.current = handleUp;

  window.addEventListener("mousemove", handleMove);
  window.addEventListener("mouseup", handleUp);
  window.addEventListener("touchmove", handleMove, { passive: false });
  window.addEventListener("touchend", handleUp);
};





  

// --- Optional useEffect to attach mobile touchstart ---
useEffect(() => {
  canvasRefs.current.forEach((canvas, index) => {
    if (!canvas) return;

    const onTouchStart = (e) => handleMouseDown(index, e);

    canvas.addEventListener("touchstart", onTouchStart, { passive: false });

    return () => canvas.removeEventListener("touchstart", onTouchStart);
  });
}, [canvasRefs, tool, selectedSymbol, selectedEmoji, color, fontSize]);

    
    
      

  


  const createTextBox = () => {
    const newBox = {

    id: Date.now(),
    pageIndex: activePage,
    top: 100,
    left: 100,
    width: 200,
    height: 40,
    content: "",
    color,
    fontSize,
  };
  setTextBoxes((prev) => [...prev, newBox]);
  addActionToHistory({
    type: 'text',
    action: 'add',
    pageIndex: activePage,
    box: { ...newBox }, // <== this is important
  });};
  
  
  // Handle Undo/Redo
  const handleSymbolSelect = (symbol) => {
    setSelectedSymbol(symbol); // Update the selected symbol (e.g., tick, cross)
  };
  const selectedEmojiRef = useRef(selectedEmoji);
  const selectedSymbolRef = useRef(selectedSymbol);
  
  useEffect(() => {
    selectedEmojiRef.current = selectedEmoji;
  }, [selectedEmoji]);
  
  useEffect(() => {
    selectedSymbolRef.current = selectedSymbol;
  }, [selectedSymbol]);
  
  
  const handleTextChange = (id, text) => {
    setTextBoxes((prev) =>
      prev.map((box) =>                                            
        box.id === id ? { ...box, content: text } : box
      )
    );
  };

  const handleDrag = (id, e) => {
    if (e.cancelable) {
      e.preventDefault();  // only preventDefault if allowed
    }
    // stop propagation & prevent scrolling/selection
    e.stopPropagation();
  
    // helper to normalize mouse/touch "point"
    const getPoint = (ev) => (ev.touches && ev.touches[0]) ? ev.touches[0] : ev;
  
    const startPoint = getPoint(e);
    const startX = startPoint.clientX;
    const startY = startPoint.clientY;
  
    const box = textBoxes.find((b) => b.id === id);
    if (!box) return;
    const origLeft = box.left;
    const origTop = box.top;
  
    const onMove = (moveEvent) => {
      // important: preventDefault to stop page scroll while dragging on mobile
      if (moveEvent.cancelable) moveEvent.preventDefault();
      const p = getPoint(moveEvent);
      const dx = p.clientX - startX;
      const dy = p.clientY - startY;
  
      setTextBoxes((prev) =>
        prev.map((b) =>
          b.id === id ? { ...b, left: Math.round(origLeft + dx), top: Math.round(origTop + dy) } : b
        )
      );
    };
  
    const onUp = () => {
      window.removeEventListener("mousemove", onMove);
      window.removeEventListener("mouseup", onUp);
      window.removeEventListener("touchmove", onMove);
      window.removeEventListener("touchend", onUp);
    };
  
    // listen with passive:false on touchmove so preventDefault works
    window.addEventListener("mousemove", onMove);
    window.addEventListener("mouseup", onUp);
    window.addEventListener("touchmove", onMove, { passive: false });
    window.addEventListener("touchend", onUp);
  };
  
  
  

  const handleResizeStart = (boxId, e) => {
    e.preventDefault();
    e.stopPropagation();
  
    // Normalize clientX, clientY
    const getClientCoords = (event) => {
      if (event.touches && event.touches[0]) {
        return {
          x: event.touches[0].clientX,
          y: event.touches[0].clientY,
        };
      }
      return {
        x: event.clientX,
        y: event.clientY,
      };
    };
  
    const { x: startX, y: startY } = getClientCoords(e);
  
    const box = textBoxes.find((b) => b.id === boxId);
    const startWidth = box.width;
    const startHeight = box.height;
  
    const onMove = (moveEvent) => {
      const { x: moveX, y: moveY } = getClientCoords(moveEvent);
  
      const newWidth = Math.max(50, startWidth + (moveX - startX));
      const newHeight = Math.max(30, startHeight + (moveY - startY));
  
      setTextBoxes((prevBoxes) =>
        prevBoxes.map((b) =>
          b.id === boxId ? { ...b, width: newWidth, height: newHeight } : b
        )
      );
  
      moveEvent.preventDefault(); // stop page scrolling while resizing
    };
  
    const onUp = () => {
      window.removeEventListener("mousemove", onMove);
      window.removeEventListener("mouseup", onUp);
      window.removeEventListener("touchmove", onMove);
      window.removeEventListener("touchend", onUp);
    };
  
    // Desktop
    window.addEventListener("mousemove", onMove);
    window.addEventListener("mouseup", onUp);
  
    // Mobile
    window.addEventListener("touchmove", onMove, { passive: false });
    window.addEventListener("touchend", onUp);
  };
  
  const hexToRgb = (hex) => {
    const bigint = parseInt(hex.replace("#", ""), 16);
    const r = (bigint >> 16) & 255;
    const g = (bigint >> 8) & 255;
    const b = bigint & 255;
    return { r, g, b };
  };
const createSymbolImage = (symbol, fontSize, color) => {
    return new Promise((resolve) => {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      
       const padding = fontSize * 0.3; // add 30% vertical and horizontal padding

  canvas.width = fontSize + padding * 2;
  canvas.height = fontSize + padding * 2;
      
      ctx.font = `${fontSize}px sans-serif`;
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.fillStyle = color;
  
      ctx.fillText(symbol, canvas.width / 2, canvas.height / 2);
      
      const imageUrl = canvas.toDataURL();
      resolve(imageUrl);
    });
  };
  
  const handleRenderSuccess = (page, pageIndex) => {
    const viewport = page.getViewport({ scale: 1 });
  
    // Use container width (screen width on mobile)
    const container = document.getElementById("pdf-container");
    const containerWidth = container ? container.offsetWidth : window.innerWidth;
  
    setPageDimensions(prev => ({
      ...prev,
      [pageIndex]: {
        width: containerWidth, // force fit width
        height: (viewport.height / viewport.width) * containerWidth, // keep aspect ratio
      },
    }));
  };
  
  const getCanvasScaling = (pageIndex, page) => {
    const canvasDims = pageDimensions[pageIndex];
  
    const canvasWidth = canvasDims?.width ?? page.getWidth();
    const canvasHeight = canvasDims?.height ?? page.getHeight();
  
    return {
      scaleX: page.getWidth() / canvasWidth,
      scaleY: page.getHeight() / canvasHeight,
      canvasWidth,
      canvasHeight,
    };
  };
  
  
  const BASE_CANVAS_WIDTH = 800;
const BASE_CANVAS_HEIGHT = 1131;

const getScaleFactorsForPage=(pdfWidth, pdfHeight)=> {
  const isLandscape = pdfWidth > pdfHeight;

  const effectiveBaseWidth = isLandscape ? BASE_CANVAS_HEIGHT : BASE_CANVAS_WIDTH;
  const effectiveBaseHeight = isLandscape ? BASE_CANVAS_WIDTH : BASE_CANVAS_HEIGHT;

  const scaleX = pdfWidth / effectiveBaseWidth;
  const scaleY = pdfHeight / effectiveBaseHeight;

  return { scaleX, scaleY, effectiveBaseWidth, effectiveBaseHeight };
}
  

const savePdf = async () => {
  setShowConfirmation(false);

  try {
    const existingPdfBytes = await fetch(file).then(res => res.arrayBuffer());
    const pdfDoc = await PDFDocument.load(existingPdfBytes);

    for (let pageIndex = 0; pageIndex < pdfDoc.getPageCount(); pageIndex++) {
      const page = pdfDoc.getPage(pageIndex);

      // ✅ Use real PDF page size
      const { width: pdfWidth, height: pdfHeight } = page.getSize();

      // ✅ Use actual canvas/pageDimensions (fallback to PDF size)
      const canvasDims = pageDimensions[pageIndex] || { width: pdfWidth, height: pdfHeight };
      const canvasW = canvasDims.width;
      const canvasH = canvasDims.height;

      const scaleX = pdfWidth / canvasW;
      const scaleY = pdfHeight / canvasH;

      const scaleCoord = (x, y) => ({
        x: x * scaleX,
        y: pdfHeight - y * scaleY // ✅ Y-flip
      });

      // ----------------- ✏️ Draw Lines (Pencil / Highlighter)
      const lines = drawnLines.current[pageIndex] || [];
      lines.forEach((line) => {
        const { r, g, b } = hexToRgb(line.color);
        const start = scaleCoord(line.start.x, line.start.y);
        const end = scaleCoord(line.end.x, line.end.y);

        page.drawLine({
          start,
          end,
          color: rgb(r / 255, g / 255, b / 255),
          thickness: line.tool === "highlight" ? 20 * scaleX : 2 * scaleX,
          opacity: line.tool === "highlight" ? 0.3 : 1,
        });
      });

      // ----------------- 🔣 Draw Symbols
      for (const symbol of drawnSymbols.current[pageIndex] || []) {
        const { symbol: symbolText, x, y, fontSize, color } = symbol;
        const { x: sx, y: sy } = scaleCoord(x, y + fontSize);

        const symbolImageUrl = await createSymbolImage(symbolText, fontSize, color);
        const imageBytes = await fetch(symbolImageUrl).then(res => res.arrayBuffer());
        const image = await pdfDoc.embedPng(imageBytes);

        page.drawImage(image, {
          x: sx,
          y: sy,
          width: fontSize * scaleX * 1.5,
          height: fontSize * scaleY * 1.5,
        });
      }

      // ----------------- 😀 Draw Emojis
      const emojis = drawnEmojis.current[pageIndex] || [];
      for (const emoji of emojis) {
        const emojiSize = emoji.fontSize || 24;
        const scaledSize = emojiSize * 1.5;
        const { x: ex, y: ey } = scaleCoord(emoji.x - scaledSize / 2, emoji.y + scaledSize / 2);

        const emojiImageUrl = await createSymbolImage(emoji.emoji, emojiSize, "#000");
        const emojiImageBytes = await fetch(emojiImageUrl).then(res => res.arrayBuffer());
        const embeddedEmoji = await pdfDoc.embedPng(emojiImageBytes);

        page.drawImage(embeddedEmoji, {
          x: ex,
          y: ey,
          width: scaledSize * scaleX,
          height: scaledSize * scaleY,
        });
      }

      // ----------------- 📝 Draw Text Boxes
      const boxes = textBoxes.filter((box) => box.pageIndex === pageIndex);
      for (const box of boxes) {
        if (!box.content) continue;
        const { r, g, b } = hexToRgb(box.color);

        const { x, y } = scaleCoord(box.left, box.top + box.height);

        page.drawText(box.content, {
          x,
          y,
          size: box.fontSize * scaleY,
          color: rgb(r / 255, g / 255, b / 255),
          maxWidth: box.width * scaleX,
        });
      }
    }

    // Save & upload
    const pdfBytes = await pdfDoc.save();
    const blob = new Blob([pdfBytes], { type: "application/pdf" });
    // saveAs(blob, "annotated.pdf");

    const formData = new FormData();
    const safeFileName = fileName || "annotated.pdf";
    formData.append("files", blob, safeFileName);

    const response = await fetch(
      `${ENVURL.PROCTUR_API_URL}/api/v2/onlineAssignment/annotate-file/save?file_id=${fileId}&inst_id=${instId}&student_id=${studentId}&attachment_id=${attachId}`,
      {
        method: "POST",
        headers: {
          Authorization: authToken,
        },
        body: formData,
      }
    );

    if (!response.ok) {
      const text = await response.text();
      throw new Error(`Server error ${response.status}: ${text}`);
    }

    toast.success("The annotated file has been saved successfully.");
  } catch (err) {
    console.error(err);
    toast.error("Failed to save PDF. Please try again.");
  }
};

  
  
  
  
  
  
  
  
  const downloadPdf = async () => {
        const existingPdfBytes = await fetch(file).then(res => res.arrayBuffer());
        const pdfDoc = await PDFDocument.load(existingPdfBytes);
      

        for (let pageIndex = 0; pageIndex < pdfDoc.getPageCount(); pageIndex++) {
          const page = pdfDoc.getPage(pageIndex);
          const { width, height } = page.getSize();
      
          
          const lines = drawnLines.current[pageIndex] || [];
          lines.forEach((line) => {
            const { r, g, b } = hexToRgb(line.color);
            page.drawLine({
              start: { x: line.start.x, y: height - line.start.y },
              end: { x: line.end.x, y: height - line.end.y },
              color: rgb(r / 255, g / 255, b / 255),
              thickness: line.tool === 'highlight' ? 20 : 2,
              opacity: line.tool === 'highlight' ? 0.3 : 1,
            });
          });
      
          for (const symbol of drawnSymbols.current[pageIndex] || []) {
            const { symbol: symbolText, x, y, fontSize, color } = symbol;
      
            // Create an image from the symbol text
            const symbolImageUrl = await createSymbolImage(symbolText, fontSize, color);
      
            // Embed the image into the PDF
            const imageBytes = await fetch(symbolImageUrl).then((res) => res.arrayBuffer());
            const image = await pdfDoc.embedPng(imageBytes);
      
            // Draw the symbol image at the specified position
            page.drawImage(image, {
              x,
              y: height - y - fontSize+ fontSize * 0.2,  // Adjust y to match PDF coordinate system
             width: fontSize*1.2 ,     // Adjust width based on fontSize
              height: fontSize *1.2,     // Adjust height based on fontSize
            });
          }

    // Inside your save/download loop, after drawing textboxes:

// Emojis
const emojis = drawnEmojis.current[pageIndex] || [];
for (const emoji of emojis) {
  const emojiSize = emoji.fontSize*1.2|| 24;
  const emojiImageUrl = await createSymbolImage(emoji.emoji, emojiSize, "#000");
  const emojiImageBytes = await fetch(emojiImageUrl).then(res => res.arrayBuffer());
  const embeddedEmoji = await pdfDoc.embedPng(emojiImageBytes);

  page.drawImage(embeddedEmoji, {
    x: emoji.x - emojiSize / 2,
    y: height - emoji.y - emojiSize / 2,
    width: emojiSize,
    height: emojiSize,
  });
}


  
    const boxes = textBoxes.filter((box) => box.pageIndex === pageIndex);
    boxes.forEach((box) => {
      if (!box.content) return;
      const { r, g, b } = hexToRgb(box.color);
      page.drawText(box.content, {
        x: box.left,
        y: height - box.top - box.height,
        size: box.fontSize,
        color: rgb(r / 255, g / 255, b / 255),
        maxWidth: box.width,
      });
    });
   

          
        }
      
        const pdfBytes = await pdfDoc.save();
        const blob = new Blob([pdfBytes], { type: "application/pdf" });
    //   saveAs(blob,"annotate.pdf")
      const url = URL.createObjectURL(blob);
  window.open(url, "_blank");
    }
    const toggleDropdown = () => {
        setDropdownVisible((prevState) => !prevState);
      };
  return (
    <>
    <div className="top-header">
      <span className="filename">{fileName}</span>
      {tools.save && (
      <button className="download-btn" title="Save Tool" onClick={handleSaveClick}>

        Save PDF
      </button>
      )}
    </div>
    <div style={{
  position: 'fixed',
  bottom: '20px',
  right: '20px',
  zIndex: 9999,
  backgroundColor: 'white',
  padding: '8px 12px',
  borderRadius: '6px',
  boxShadow: '0 2px 6px rgba(0,0,0,0.2)',
  fontSize: '14px'
}}>

    <label>
  <input
    type="checkbox"
    checked={showOriginal}
    onChange={(e) => {
      const isChecked = e.target.checked;
      setShowOriginal(isChecked);

      if (isChecked) {
        // Backup current state
        backupState.current = {
          lines: JSON.parse(JSON.stringify(drawnLines.current)),
          symbols: JSON.parse(JSON.stringify(drawnSymbols.current)),
          emojis: JSON.parse(JSON.stringify(drawnEmojis.current)),
          texts: [...textBoxes],
        };

        // Clear everything (simulate reset)
        Object.keys(drawnLines.current).forEach((page) => {
          drawnLines.current[page] = [];
          drawnSymbols.current[page] = [];
          drawnEmojis.current[page] = [];
        });
        setTextBoxes([]);
        // Redraw blank
        Object.keys(drawnLines.current).forEach((pageIndex) => drawAllLines(pageIndex));
      } else {
        // Restore from backup
        if (backupState.current) {
          drawnLines.current = JSON.parse(JSON.stringify(backupState.current.lines));
          drawnSymbols.current = JSON.parse(JSON.stringify(backupState.current.symbols));
          drawnEmojis.current = JSON.parse(JSON.stringify(backupState.current.emojis));
          setTextBoxes([...backupState.current.texts]);
          Object.keys(drawnLines.current).forEach((pageIndex) => drawAllLines(pageIndex));
        }
      }
    }}
  />
  View Original
</label>
</div>
    {showConfirmation && (
  <div className="modal-overlay">
    <div className="modal-content">
      <p className="modal-message">Annotations cannot be modified or deleted after saving. Do you want to proceed?</p>
      <div className="modal-buttons">
        <button className="cancel-button" onClick={() => setShowConfirmation(false)}>Cancel</button>
        <button className="save-button" onClick={savePdf}>Proceed To Save</button>
      </div>
    </div>
  </div>)}
    <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
    <div className="toolbar fixed-toolbar">
    {tools.pencil && (
    <button className={tool === "pencil" ? "active" : ""} title="Pencil Tool" onClick={() => setTool("pencil")}>✏️</button>
  )}
  {tools.highlight && (
    <button className={tool === "highlight" ? "active" : ""} title="Highlighter Tool" onClick={() => setTool("highlight")}>🟨</button>
  )}
  {tools.freeDrawing && (
    <button className={tool === "free-drawing" ? "active" : ""} title="Free-drawing Tool" onClick={() => setTool("free-drawing")}>🖊️</button>
  )}
  {tools.text && (
    <button className={tool === "text" ? "active" : ""} title="Text Tool" onClick={() => { setTool("text"); createTextBox(); }}>🔤</button>
  )}
  {tools.reset && (
  <button title="Reset All Tool" onClick={handleReset}>♻️</button>
  )}
 {tools.undo && (
  <button title="Undo Tool" onClick={handleUndo}>↩️</button>
 )}
  {tools.redo && (
  <button title="Redo Tool" onClick={handleRedo}>↪️</button>
  )}
  {tools.eraser && (
  <button
  className={tool === "eraser" ? "active" : ""}
  title="Eraser Tool"
  onClick={() => setTool("eraser")}
>
  🧽
</button>
)}
   {/* {tools.save && (
  <button title="Save Tool" onClick={handleSaveClick}>💾</button>
   )} */}
   {tools.emoji && (
 <div style={{ position: "relative" }}>
 <button
   className={tool === "emoji" ? "active" : ""}
   title="Emoji Tool"
   onClick={() => {
     setTool("emoji");
     setDropdownVisible((prev) => !prev);
   }}
 >
   😀
 </button>

 {tool === "emoji" && isDropdownVisible && (
   <div
     style={{
       position: "absolute",
       bottom: "40px", // show above the button
       left: 0,
       display: "grid",
       gridTemplateColumns: "1fr 1fr",
       gap: "6px",
       background: "#fff",
       border: "1px solid #ccc",
       padding: "8px",
       borderRadius: "6px",
       zIndex: 9999,
     }}
   >
     {["😀", "😎", "😍", "😊","🔥", "👍","👌","👎", "🎯", "❤️","✅","⭐","💯","👏","✏️","📝"].map((emoji) => (
       <span
         key={emoji}
         onClick={() => {
           setSelectedEmoji(emoji);
           setDropdownVisible(false); // close dropdown
         }}
         style={{
           fontSize: "20px",
           cursor: "pointer",
           padding: "4px",
           borderRadius: "4px",
           textAlign: "center",
           userSelect: "none",
         }}
       >
         {emoji}
       </span>
     ))}
   </div>
 )}
</div>

   )}
  {tools.symbol && (

  <select
  title="Symbol Tool"
    onChange={(e) => {
      const value = e.target.value;
      if (value) {
        handleSymbolSelect(value);
        setTool("symbol");
      }
      e.target.selectedIndex = 0;
    }}
  >
    <option value="">𖤐</option>
    <option value="✓">✓ Tick</option>
    <option value="✕">✕ Cross</option>
    <option value="▢">▢ Square</option>
    <option value="○">○ Circle</option>
    <option value="☆">☆ Star</option>
    <option value="△">△ Triangle</option>
    <option value="→">→ Arrow</option>
    <option value="♡">♡ Heart</option>
  </select>
  )}
  {tools.color && (

  <input type="color" title="Color Tool" value={color} onChange={(e) => setColor(e.target.value)} />
  )}
    {tools.size && (

  <input type="number" title="Size Tool" value={fontSize} onChange={(e) => setFontSize(Number(e.target.value))}  />
    )}
 
</div>



      <div id="pdf-container" >
        {file && (
          <Document file={file} onLoadSuccess={handleLoadSuccess}>
        {Array.from(new Array(numPages), (_, pageIndex) => (
  <div
    key={pageIndex}
    className="pdf-page-container"
    style={{ width: "100%", overflowX: "hidden", display: "flex", maxWidth: "100%",         // prevent overflow
    margin: "0 auto", paddingLeft: "180px",  // 👈 space for toolbar
    boxSizing: "border-box",           // makes centering possible
    justifyContent: "center", }}    onMouseEnter={() => setActivePage(pageIndex)}
    onClick={() => setSelectedBox(null)}
  >
      <div style={{ position: "relative", width: "100%" }}>

    <Page
      pageNumber={pageIndex + 1}
      width={pageDimensions[pageIndex]?.width}
      height={pageDimensions[pageIndex]?.height}      renderAnnotationLayer={false}
      renderTextLayer={false}
      
  onRenderSuccess={(page) => handleRenderSuccess(page, pageIndex)}
      // onRenderSuccess={(page) => {
      //   const viewport = page.getViewport({ scale: 1.0 });
      //   const canvas = canvasRefs.current[pageIndex];
      //   if (canvas) {
      //     canvas.width = viewport.width;
      //     canvas.height = viewport.height;
      //     drawAllLines(pageIndex);
      //   }
      // }}
    />



    <canvas
      ref={(ref) => (canvasRefs.current[pageIndex] = ref)}
      width={pageDimensions[pageIndex]?.width}
    height={pageDimensions[pageIndex]?.height}
      onMouseDown={(e) => {
        handleMouseDown(pageIndex, e);
        handleCanvasClick(e, pageIndex);
      }}      className={`drawing-canvas ${tool === "eraser" ? "eraser-cursor" : ""}`}
      style={{
        position: "absolute",
        top: 0,
        left: 0,
        zIndex: 5,
        cursor: tool === "text" ? "default" : "crosshair",
      
      }}
    />
      </div>

{textBoxes
  .filter((box) => box.pageIndex === pageIndex)
  .map((box) => (
    <div
      key={box.id}
      style={{
        position: "absolute",
        left: box.left,
        top: box.top,
        width: box.width,
        height: box.height,
        border:
          selectedBox === box.id
            ? "1px dashed black"
            : box.content === ""
            ? "1px dashed lightgrey"
            : "none",
        cursor: "move", // put move cursor on handle only
        zIndex: 10,
      }}
      // DO NOT attach drag to this container
    >
      {/* Drag handle (visible area to start dragging) */}
      <div
        onMouseDown={(e) => handleDrag(box.id, e)}
        onTouchStart={(e) => handleDrag(box.id, e)}
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          height: 28,           // handle height
          cursor: "move",
          zIndex: 20,
          // visually you can show a faint bar or keep transparent:
          background: "transparent",
        }}
        onClick={(e) => { e.stopPropagation(); setSelectedBox(box.id); }}
      />

      {/* Textarea below the handle */}
      <textarea
        value={box.content}
        onChange={(e) => handleTextChange(box.id, e.target.value)}
        onMouseDown={(e) => e.stopPropagation()}   // prevent starting a drag accidentally
        onTouchStart={(e) => e.stopPropagation()}   // same for touch
        onClick={(e) => { e.stopPropagation(); setSelectedBox(box.id); }}
        style={{
         
          width: "100%",
          height: `100%`,  // leave space for the handle
          fontSize: box.fontSize,
          color: box.color,
          backgroundColor: "transparent",
          border: "none",
          resize: "none",
          outline: "none",
        }}
        placeholder="Type here..."
      />
            {emojiAnnotations
       .filter((e) => e.pageIndex === pageIndex)
       .map((e) => (
     <div
      key={e.id}
      style={{
        position: "absolute",
        top: e.y,
        left: e.x,
        fontSize: "24px",
        userSelect: "none",
        cursor: "default",
        zIndex: 10,
      }}
    >
      {e.emoji}
    </div>
  ))}

      {/* resize handle */}
      {selectedBox === box.id && (
        <div
          onMouseDown={(e) => handleResizeStart(box.id, e)}
          onTouchStart={(e) => handleResizeStart(box.id, e)}
          style={{
            position: "absolute",
            bottom: 0,
            right: 0,
            width: 12,
            height: 12,
            backgroundColor: "grey",
            cursor: "se-resize",
            zIndex: 30,
          }}
        />
      )}
    </div>
  ))}

{tool === 'eraser' && activePage === pageIndex && (
  <div
    ref={eraserRef}
    tabIndex={-1} // Prevent focus
    onMouseDown={(e) => {
      e.preventDefault();
      e.stopPropagation();
      setIsDraggingEraser(true);
    }}
    onTouchStart={(e) => {
      setIsDraggingEraser(true);
    }}
    
        style={{
          position: 'absolute',
          left: eraserRect.x+50,
          top: eraserRect.y+150,
          width: eraserRect.width,
          height: eraserRect.height,
          pointerEvents: 'none',             // allow canvas interactions
          zIndex: 100,
          userSelect: 'none',
          touchAction: 'none',
        }}
      >
        <img
          src={eraserr}
          alt="eraser"
          style={{
            width: '100%',
            height: '100%',
            display: 'block',
            pointerEvents: 'none',
            userSelect: 'none',
          }}
       
    

  onMouseDown={() => setIsDraggingEraser(true)}
  onTouchStart={() => setIsDraggingEraser(true)}
/>

  </div>
)}



              </div>
            ))}
          </Document>
        )}
      </div>

    </div>
      </>
  );
};

export default PdfAnnotator;
